export enum ROLES {
  FRANCHISEE = 'PS_FRANQUEADO',
  MANAGEMENT = 'PS_COLABORADOR',
  PS_FRANQUEADO_AERO = 'PS_FRANQUEADO_AERO',
  PS_FRANQUEADO_AERO_CERTIFICADO = 'PS_FRANQUEADO_AERO_CERTIFICADO',
}
